// extracted by mini-css-extract-plugin
export default {"root":"TcbUj","id":"mq2_F","author":"Stg3i","modal":"vC68i","noBorder":"QFe9f","dropdown":"Bz2Es","actionCell":"vOZP3","boolean":"fHbiY"};